import i18next from 'i18next'
import React, { Component, useCallback } from 'react'
import {
  Card,
  ContextMenu,
  Hotkey,
  Hotkeys, HotkeysTarget,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  Position,
  Tooltip
} from '@blueprintjs/core'
import {
  copyTextToClipBoard, decorateNode,
  getCaretCoordinates, parseLogicSymbols,
  pasteTextFromClipBoard, showToastByMenuDirection, toggleDecorateNode,
  truncateDefault, undoManager
} from '../../../../helper/functions'
import { Key } from '../../../../helper/classes'
import { hasScrollbarAlways, hotKeyClass } from '../../../../helper/CSSclasses'
// import { focusToWindow } from '../../window/window1'
import { globalOnDemandVars } from '../../../../helper/context'
import { throttle, defer } from 'lodash'
import UploadInNodes from '../../../addon/addons/parts/uploadInNodes'
import { CustomEditableTextContent2 } from './customEditableTextContent'
import { css as classname, cx } from 'emotion'
import insertTextAtCursor from 'insert-text-at-cursor'
import { decoratingConfig, OverlayProps } from '../../../../helper/configs'
import { ctrlOrCmd } from '../../../../helper/useEnvironment'
import { updateMediaItemF } from '../../../../backend/mediaItems/updateData'
import produce from 'immer'
import { withTranslation } from 'react-i18next'

// 이상하게도 단지 '../../../commonInterface/toast' 를 import 해오는 것만으로 error뜸(그것도 window1에서. 아마 HotKeyTarget 때문?)
// 그래서 이걸 딴 파일로 옮긴 후에 다시 import 해왔다
// import { showToastByMenuDirection } from '../../../commonInterface/toast'

const onKeyDown = (e) => {
  // if (e.charCode === 10 && e.altKey) {
  if (e.altKey) {
    e.preventDefault()
  }
}

export const regexFor$$ = /(^\$.*[^\\]\$|[^\\]\$.*[^\\]\$)/
export const regexForMediaBlock = /!\[.*]\(.*\)/
const regexForNotBlank = /\S/
const regexForClosingLetters = /[\])>}]/
const regexForNotAlphabet = /\W/
const regexForCloze = /^{{.*}}$/
const regexForHighlight = /^]\(\d+\)/
const regexForNumber = /\d+/

const PasteComp = ({ pastedWords, setState, onChange, value }) => {
  const mapCallback = useCallback(
    (word, index, array) => {
      const isClose = regexForCloze.test(word)
      return (
        <a key={word + index} className={classname`
          background-color: ${isClose ? '#FF7373' : 'var(--gray3)'}; border-radius: 4px; padding: 0 4px;
          `} onMouseDown={(e) => {
          e.preventDefault()

          const prevPastedString = pastedWords.join(' ')
          let modifiedWord

          if (isClose) {
            modifiedWord = word.slice(2, -2)
          } else {
            modifiedWord = '{{' + word + '}}'
          }

          const nextPastedWords = produce(pastedWords, draft => {
            draft[index] = modifiedWord
          })
          const nextPastedString = nextPastedWords.join(' ')

          setState(nextPastedWords)
          onChange(value.replace(prevPastedString, nextPastedString))
        }}>
          {word}
        </a>)
    }, [pastedWords, setState, onChange, value]
  )

  return (
    <Card className={classname`max-width: 500px; max-height: 90px; overflow: auto;`}>
      <div>{i18next.t('Generate cloze by clicking words')}</div>
      <div className={classname`font-size: 18px; & > * + * { margin-left: 2px; }`}>{pastedWords.map(mapCallback)}</div>
    </Card>
  )
}

const PreviewComp = ({ value }) => {
  return (
    <div className={cx(hasScrollbarAlways, classname`width: 500px; height: 90px; overflow: auto; position: relative; font-size: 18px;`)}>
      <CustomEditableTextContent2 children={value} refCalc={() => {}} style={{ height: null, width: '100%', padding: '2px' }} />
    </div>
  )
}

class TextAreaMode extends Component {
  constructor (props) {
    super(props)
    this.state = {
      popoverOpen: false,
      onPaste: false,
      pastedWords: []
      // mediaUploadBoolean: false,
      // mediaUploadType: null
    }

    this.textareaRef = null
    // this.isOnContextMenu = false
    const { moveToUpperET, moveToLowerET } = this.props
    this.backspaceHandler = (e) => {
      const ref = this.textareaRef
      if (!ref.value.length || ref.selectionStart === 0) {

      } else {
        const caretPosition1 = ref.selectionStart
        const caretPosition2 = ref.selectionEnd
        const beforeCaret = ref.value[caretPosition1 - 1]
        const afterCaret = ref.value[caretPosition2]
        if (
          (beforeCaret === '(' && afterCaret === ')') || (beforeCaret === '[' && afterCaret === ']') ||
          (beforeCaret === '{' && afterCaret === '}') || (beforeCaret === '$' && afterCaret === '$') || (beforeCaret === '<' && afterCaret === '>') ||
          (beforeCaret === '"' && afterCaret === '"') || (beforeCaret === "'" && afterCaret === "'") ||
          (beforeCaret === '*' && afterCaret === '*') || (beforeCaret === '_' && afterCaret === '_') ||
          (beforeCaret === '`' && afterCaret === '`')
        ) {
          e.preventDefault()

          let newCaretPosition1, newCaretPosition2, newString
          if (caretPosition1 !== caretPosition2) {
            const stringBeforeCaret = ref.value.substring(0, caretPosition1 - 1)
            const stringAfterCaret = ref.value.substring(caretPosition2 + 1)
            newString = stringBeforeCaret + ref.value.substring(caretPosition1, caretPosition2) + stringAfterCaret
            newCaretPosition1 = caretPosition1 - 1
            newCaretPosition2 = caretPosition2 - 1
          } else {
            const stringBeforeCaret = ref.value.substring(0, caretPosition1 - 1)
            const stringAfterCaret = ref.value.substring(caretPosition2 + 1)
            newString = stringBeforeCaret + stringAfterCaret
            newCaretPosition1 = caretPosition1 - 1
            newCaretPosition2 = newCaretPosition1
          }

          this.props.onChange({ target: { value: newString } })
          defer(() => {
            ref.setSelectionRange(newCaretPosition1, newCaretPosition2)
          })
        }
      }

      this.props.backspaceHandler(e)
    }

    this.generateAutoCompletionFunctionFor1Char = (char) => {
      return (e) => {
        const ref = this.textareaRef
        if (ref.selectionStart !== ref.selectionEnd) {
          e.preventDefault()
          const caretStart = ref.selectionStart
          const caretEnd = ref.selectionEnd
          const string = ref.value
          // const stringLength = string.length
          const subString = string.substring(caretStart, caretEnd)
          const stringBeforeCaret = string.substring(0, caretStart)
          const stringAfterCaret = string.substring(caretEnd)
          const newString = stringBeforeCaret + char + subString + char + stringAfterCaret
          this.props.onChange({ target: { value: newString } })
          defer(() => {
            ref.setSelectionRange(caretStart + 1, caretEnd + 1)
          })
          // -----------------------------------------------------------------------------------------------------------
          undoManager.add({
            redo: () => {
              this.props.onChange({ target: { value: newString } })
              defer(() => {
                ref.setSelectionRange(caretStart + 1, caretEnd + 1)
              })
            },
            undo: () => {
              this.props.onChange({ target: { value: string } })
              defer(() => {
                ref.setSelectionRange(caretStart, caretEnd)
              })
            }
          })
        } else {
          const caretPosition = ref.selectionStart
          const afterCaret = ref.value[caretPosition]
          const beforeCaret = caretPosition ? ref.value[caretPosition - 1] : null

          if (afterCaret === char) {
            e.preventDefault()
            const newCaretPosition = caretPosition + 1
            defer(() => {
              ref.setSelectionRange(newCaretPosition, newCaretPosition)
            })
          } else if ((ref.value.length) !== caretPosition && regexForNotBlank.test(afterCaret) && (!regexForClosingLetters.test(afterCaret))) {

          } else if (
            ((caretPosition === 0) || (regexForNotAlphabet.test(beforeCaret)))
          ) {
            e.preventDefault()
            const string = ref.value
            const stringBeforeCaret = ref.value.substring(0, caretPosition)
            const stringAfterCaret = ref.value.substring(caretPosition)
            const newString = stringBeforeCaret + char + char + stringAfterCaret
            const newCaretPosition = caretPosition + 1
            this.props.onChange({ target: { value: newString } })
            defer(() => {
              ref.setSelectionRange(newCaretPosition, newCaretPosition)
            })
            // -----------------------------------------------------------------------------------------------------------
            undoManager.add({
              redo: () => {
                this.props.onChange({ target: { value: newString } })
                defer(() => {
                  ref.setSelectionRange(newCaretPosition, newCaretPosition)
                })
              },
              undo: () => {
                this.props.onChange({ target: { value: string } })
                defer(() => {
                  ref.setSelectionRange(caretPosition, caretPosition)
                })
              }
            })
          }
        }
      }
    }

    this.generateAutoCompletionFunctionFor2Char = (char) => {
      return (e) => {
        const ref = this.textareaRef
        if (ref.selectionStart !== ref.selectionEnd) {
          e.preventDefault()
          const caretStart = ref.selectionStart
          const caretEnd = ref.selectionEnd
          const string = ref.value
          // const stringLength = string.length
          const subString = string.substring(caretStart, caretEnd)
          const stringBeforeCaret = string.substring(0, caretStart)
          const stringAfterCaret = string.substring(caretEnd)
          const newString = stringBeforeCaret + char[0] + subString + char[1] + stringAfterCaret
          this.props.onChange({ target: { value: newString } })
          defer(() => {
            ref.setSelectionRange(caretStart + 1, caretEnd + 1)
          })

          // -----------------------------------------------------------------------------------------------------------
          undoManager.add({
            redo: () => {
              this.props.onChange({ target: { value: newString } })
              defer(() => {
                ref.setSelectionRange(caretStart + 1, caretEnd + 1)
              })
            },
            undo: () => {
              this.props.onChange({ target: { value: string } })
              defer(() => {
                ref.setSelectionRange(caretStart, caretEnd)
              })
            }
          })
        } else {
          const caretPosition = ref.selectionStart
          // if (process.env.NODE_ENV !== 'production') {
          //   console.tron.display({
          //     name: 'autoComplete 1',
          //     preview: ref.value,
          //     value: {
          //       value: ref.value,
          //       length: ref.value.length,
          //       caretPosition,
          //       test: (ref.value.length) !== caretPosition && !regexForBlank.test(ref.value[caretPosition])
          //     }
          //     // , important: true
          //   })
          // }
          const afterCaret = ref.value[caretPosition]
          if ((ref.value.length) !== caretPosition && regexForNotBlank.test(afterCaret) && (!regexForClosingLetters.test(afterCaret)) && !(
            afterCaret === char[1]
          )) {

          } else {
            e.preventDefault()
            const string = ref.value
            const stringBeforeCaret = string.substring(0, caretPosition)
            const stringAfterCaret = string.substring(caretPosition)
            const newString = stringBeforeCaret + char + stringAfterCaret
            const newCaretPosition = caretPosition + 1
            this.props.onChange({ target: { value: newString } })
            defer(() => {
              ref.setSelectionRange(newCaretPosition, newCaretPosition)
            })
            // -----------------------------------------------------------------------------------------------------------
            undoManager.add({
              redo: () => {
                this.props.onChange({ target: { value: newString } })
                defer(() => {
                  ref.setSelectionRange(newCaretPosition, newCaretPosition)
                })
              },
              undo: () => {
                this.props.onChange({ target: { value: string } })
                defer(() => {
                  ref.setSelectionRange(caretPosition, caretPosition)
                })
              }
            })
          }
        }
      }
    }

    this.generateAutoCompletionFunctionFor2Char2 = (char) => {
      return (e) => {
        const ref = this.textareaRef
        if (ref.selectionStart !== ref.selectionEnd) {
          e.preventDefault()
          const caretStart = ref.selectionStart
          const caretEnd = ref.selectionEnd
          const string = ref.value
          // const stringLength = string.length
          const subString = string.substring(caretStart, caretEnd)
          const stringBeforeCaret = string.substring(0, caretStart)
          const stringAfterCaret = string.substring(caretEnd)
          const newString = stringBeforeCaret + char[0] + subString + char[1] + stringAfterCaret
          this.props.onChange({ target: { value: newString } })
          defer(() => {
            ref.setSelectionRange(caretStart + 1, caretEnd + 1)
          })
          // -----------------------------------------------------------------------------------------------------------
          undoManager.add({
            redo: () => {
              this.props.onChange({ target: { value: newString } })
              defer(() => {
                ref.setSelectionRange(caretStart + 1, caretEnd + 1)
              })
            },
            undo: () => {
              this.props.onChange({ target: { value: string } })
              defer(() => {
                ref.setSelectionRange(caretStart, caretEnd)
              })
            }
          })
        }
      }
    }

    this.generateSkipFunction = (char) =>
      (e) => {
        const ref = this.textareaRef
        if (ref.selectionStart === ref.selectionEnd && ref.value[ref.selectionStart] === char) {
          e.preventDefault()
          const newCaretPosition = ref.selectionStart + 1
          ref.setSelectionRange(newCaretPosition, newCaretPosition)
        }
      }

    this.generateFormattingFunction1 = (name, chars) => {
      const lengthOfChars = chars.length
      return (e) => {
        e.preventDefault()
        const ref = this.textareaRef
        const caretStart = ref.selectionStart
        const caretEnd = ref.selectionEnd
        if (caretStart === caretEnd) {
          const nodeId = globalOnDemandVars.focusedNode().id
          decorateNode(nodeId, name)
        } else {
          const string = ref.value
          // const stringLength = string.length
          const subString = string.substring(caretStart, caretEnd)
          const stringBeforeCaret = string.substring(0, caretStart)
          const stringAfterCaret = string.substring(caretEnd)
          if (stringBeforeCaret.endsWith(chars) && stringAfterCaret.startsWith(chars)) {
            const newString = stringBeforeCaret.slice(0, stringBeforeCaret.length - lengthOfChars) + subString + stringAfterCaret.slice(lengthOfChars)
            this.props.onChange({ target: { value: newString } })
            defer(() => {
              ref.setSelectionRange(caretStart - lengthOfChars, caretEnd - lengthOfChars)
            })
            // -----------------------------------------------------------------------------------------------------------
            undoManager.add({
              redo: () => {
                this.props.onChange({ target: { value: newString } })
                defer(() => {
                  ref.setSelectionRange(caretStart - lengthOfChars, caretEnd - lengthOfChars)
                })
              },
              undo: () => {
                this.props.onChange({ target: { value: string } })
                defer(() => {
                  ref.setSelectionRange(caretStart, caretEnd)
                })
              }
            })
          } else {
            const newString = stringBeforeCaret + chars + subString + chars + stringAfterCaret
            this.props.onChange({ target: { value: newString } })
            defer(() => {
              ref.setSelectionRange(caretStart + lengthOfChars, caretEnd + lengthOfChars)
            })
            // -----------------------------------------------------------------------------------------------------------
            undoManager.add({
              redo: () => {
                this.props.onChange({ target: { value: newString } })
                defer(() => {
                  ref.setSelectionRange(caretStart + lengthOfChars, caretEnd + lengthOfChars)
                })
              },
              undo: () => {
                this.props.onChange({ target: { value: string } })
                defer(() => {
                  ref.setSelectionRange(caretStart, caretEnd)
                })
              }
            })
          }
        }
      }
    }

    this.keys = [
      new Key('Go up', 'up', () => {
        const caretPosition = getCaretCoordinates(this.textareaRef, this.textareaRef.selectionEnd)
        // console.tron.display({
        //   name: 'caret position - up',
        //   value: caretPosition,
        //   preview: caretPosition.top
        //   // , important: true
        // })
        if (caretPosition.top < 10) {
          defer(() => {
            moveToUpperET()
          })
          return false
        } else {
          return true
        }
      }
      ),
      new Key('Go down', 'down', () => {
        const caretPosition = getCaretCoordinates(this.textareaRef, this.textareaRef.selectionEnd)
        // console.tron.display({
        //   name: 'caret position - down',
        //   value: caretPosition,
        //   preview: caretPosition.bottom
        //   // , important: true
        // })
        if (caretPosition.bottom < 10) {
          defer(() => {
            moveToLowerET()
          })
          return false
        } else {
          return true
        }
      }),
      new Key('Backspace', 'backspace', this.backspaceHandler),
      new Key('Add', 'enter', () => {
        // const caretPosition = getCaretCoordinates(this.textareaRef, this.textareaRef.selectionEnd)
        this.props.addNodeF(this.textareaRef.value && (this.textareaRef.selectionStart === 0 && this.textareaRef.selectionEnd === 0))
      }),
      new Key('Exit', 'esc', () => {
        globalOnDemandVars.updateCurrentNodeByChangeOfContents()(() => {
          if (ContextMenu.isOpen()) {
            ContextMenu.hide()
          }
          this.textareaRef.blur()
          this.props.toggleEditing()
          // focusToWindow()
          globalOnDemandVars.focusToWindow() && globalOnDemandVars.focusToWindow()()
        })
      }),
      new Key('block alt', 'alt', () => {
        // console.tron.log('alt 눌림')
      }),
      new Key('autoCompleteFor()', '(', this.generateAutoCompletionFunctionFor2Char('()')),
      new Key('autoCompleteFor[]', '[', this.generateAutoCompletionFunctionFor2Char('[]')),
      new Key('autoCompleteFor{}', '{', this.generateAutoCompletionFunctionFor2Char('{}')),
      new Key('autoCompleteFor{}', '<', this.generateAutoCompletionFunctionFor2Char2('<>')),
      // new Key('autoCompleteFor$$', '$', this.generateAutoCompletionFunctionFor2Char('$$')),
      new Key('skipFor)', ')', this.generateSkipFunction(')')),
      new Key('skipFor]', ']', this.generateSkipFunction(']')),
      new Key('skipFor}', '}', this.generateSkipFunction('}')),
      new Key('skipFor>', '>', this.generateSkipFunction('>')),
      new Key("autoCompleteFor'", "'", this.generateAutoCompletionFunctionFor1Char("'")),
      new Key('autoCompleteFor"', '"', this.generateAutoCompletionFunctionFor1Char('"')),
      new Key('autoCompleteFor$', '$', this.generateAutoCompletionFunctionFor1Char('$')),
      new Key('autoCompleteFor`', '`', this.generateAutoCompletionFunctionFor1Char('`')),
      new Key('autoCompleteForBold', 'mod + b', this.generateFormattingFunction1('bold', '**')),
      new Key('autoCompleteForItalic', 'mod + i', this.generateFormattingFunction1('italic', '_')),
      new Key('autoCompleteForUnderline', 'mod + u', this.generateFormattingFunction1('underline', '__')),
      new Key('autoCompleteForStrike', 'mod + s', this.generateFormattingFunction1('strike', '~~')),
      new Key('boxHighlight', 'mod + shift + b', () => {
        const node = globalOnDemandVars.focusedNode()
        toggleDecorateNode(node.id, 'boxHighlight')
      }),
      new Key('heading', 'mod + shift + h', () => {
        const node = globalOnDemandVars.focusedNode()
        toggleDecorateNode(node.id, 'heading')
      }),
      new Key('numbered list', 'mod + shift + o', () => {
        const node = globalOnDemandVars.focusedNode()
        decorateNode(node.id, 'numberedList')
      }),
      new Key('highlight', 'mod + shift + l', (e) => {
        e.preventDefault()

        const ref = this.textareaRef
        const caretStart = ref.selectionStart
        const caretEnd = ref.selectionEnd
        if (caretStart === caretEnd) {
          const nodeId = globalOnDemandVars.focusedNode().id
          toggleDecorateNode(nodeId, 'highlight')
        } else {
          const highlightConfig = decoratingConfig.highlight
          const string = ref.value
          const subString = string.substring(caretStart, caretEnd)
          const stringBeforeCaret = string.substring(0, caretStart)
          const stringAfterCaret = string.substring(caretEnd)

          let newString, newCaretStart, newCaretEnd
          if (stringBeforeCaret.endsWith('[') && regexForHighlight.test(stringAfterCaret)) {
            const currentNumberAsString = stringAfterCaret.match(regexForNumber)[0]
            const currentNumber = Number(currentNumberAsString)

            if (currentNumber === highlightConfig.lastOptionNumber) {
              newString = stringBeforeCaret.slice(0, -1) + subString + stringAfterCaret.slice(2 + currentNumberAsString.length + 1)
              newCaretStart = caretStart - 1
              newCaretEnd = caretEnd - 1
            } else {
              const newStringAfterCaret = stringAfterCaret.replace(regexForNumber, (match) => {
                const currentNumber = Number(match)
                let nextNumber
                if ((currentNumber >= 1) && (currentNumber < highlightConfig.lastOptionNumber)) {
                  nextNumber = currentNumber + 1
                } else {
                  nextNumber = 1
                }
                return nextNumber
              })

              newString = stringBeforeCaret + subString + newStringAfterCaret
              newCaretStart = caretStart
              newCaretEnd = caretEnd
            }
          } else {
            newString = stringBeforeCaret + '[' + subString + '](1)' + stringAfterCaret
            newCaretStart = caretStart + 1
            newCaretEnd = caretEnd + 1
          }

          this.props.onChange({ target: { value: newString } })
          defer(() => {
            ref.setSelectionRange(newCaretStart, newCaretEnd)
          })
          // -----------------------------------------------------------------------------------------------------------
          undoManager.add({
            redo: () => {
              this.props.onChange({ target: { value: newString } })
              defer(() => {
                ref.setSelectionRange(newCaretStart, newCaretEnd)
              })
            },
            undo: () => {
              this.props.onChange({ target: { value: string } })
              defer(() => {
                ref.setSelectionRange(caretStart, caretEnd)
              })
            }
          })
        }
      }),
      new Key('Undo', 'mod + z', () => {
        const originalValue = this.props.value
        defer(() => {
          if (originalValue === this.props.value) {
            undoManager.undo()
          }
        })
      }, null, null, { notPreventDefault: true }),
      new Key('Redo 1', 'mod + shift + z', () => {
        const originalValue = this.props.value
        defer(() => {
          if (originalValue === this.props.value) {
            undoManager.redo()
          }
        })
      }, null, null, { notPreventDefault: true }),
      new Key('Redo 2', 'mod + y', () => {
        const originalValue = this.props.value
        defer(() => {
          if (originalValue === this.props.value) {
            undoManager.redo()
          }
        })
      }, null, null, { notPreventDefault: true }),
      new Key('ctrlA', 'mod + a', (e) => {
        e.preventDefault()

        const ref = this.textareaRef
        const caretStart = ref.selectionStart
        const caretEnd = ref.selectionEnd
        const string = ref.value
        const substring = string.substring(caretStart, caretEnd)

        if (string !== substring) {
          ref.setSelectionRange(0, string.length)
          return null
        }

        this.props.onCtrlA(e)
        // this.textareaRef.focus()
      }),
      new Key('shiftUp', 'shift + up', (e) => {
        e.preventDefault()

        const ref = this.textareaRef
        const caretStart = ref.selectionStart

        if (caretStart !== 0) {
          ref.setSelectionRange(0, ref.selectionEnd)
          return null
        }

        this.props.onCtrlA(e, true, true)
      }),
      new Key('shiftDown', 'shift + down', (e) => {
        e.preventDefault()

        const ref = this.textareaRef
        const caretEnd = ref.selectionEnd
        const string = ref.value

        if (caretEnd !== string.length) {
          ref.setSelectionRange(ref.selectionStart, string.length)
          return null
        }

        this.props.onCtrlA(e, true, false)
      })
    ]
  }

  // static contextType = GlobalContext

  shouldComponentUpdate (nextProps, nextState) {
    return (this.props.value !== nextProps.value || this.props.style.height !== nextProps.style.height ||
      this.state.popoverOpen !== nextState.popoverOpen
      // || this.state.mediaUploadBoolean !== nextState.mediaUploadBoolean || this.state.mediaUploadType !== nextState.mediaUploadType
    )
  }

  updatePopoverState = throttle(() => {
    if (regexFor$$.test(this.props.value) || regexForMediaBlock.test(this.props.value)) {
      this.setState({ popoverOpen: true })
    // } else if (!this.state.onPaste && !this.state.mediaUploadBoolean) {
    } else if (!this.state.onPaste) {
      this.setState({ popoverOpen: false })
    }
  }, 500, { leading: true, trailing: true }
  )

  componentDidUpdate (prevProps, prevState) {
    if (this.props.value !== prevProps.value) {
      this.updatePopoverState()
    }
  }

  refF = (e) => {
    this.props.refCalc(e)
    this.textareaRef = e
  }

  nodeTextOnChange = (newValue) => {
    this.props.onChange({ target: { value: newValue } })
  }

  insertKeys = [
    new Key(i18next.t('Insert media from Type 1'), 'alt + 1', () => {
      const waitingItems = globalOnDemandVars.waitingItemsForType1()
      if (waitingItems.length) {
        const setWaitingItems = globalOnDemandVars.set_waitingItemsForType1
        const usedItems = globalOnDemandVars.usedItemsForType1()
        const setUsedItems = globalOnDemandVars.set_usedItemsForType1

        const nextWaitingItems = Array.from(waitingItems)
        const nextUsedItems = Array.from(usedItems)

        const firstWaitingItems = nextWaitingItems.shift()

        nextUsedItems.unshift(firstWaitingItems)

        insertTextAtCursor(this.textareaRef, `![${firstWaitingItems.type}](${firstWaitingItems.backId})`)

        setWaitingItems(nextWaitingItems)
        setUsedItems(nextUsedItems)

        updateMediaItemF(firstWaitingItems.globalId, {
          inWaitingItemsForType1: false,
          inUsedItemsForType1: true,
          type1Order: 0
        })

        showToastByMenuDirection({
          message: i18next.t('insertedFromT1', { itemName: truncateDefault(firstWaitingItems.title) }),
          intent: 'success',
          icon: 'import'
        })
      } else {
        showToastByMenuDirection({
          message: i18next.t('There is nothing to insert from Waiting Items of Type 1'),
          icon: 'issue'
        })
      }
    }, 'import')
  ]

  _menu = (
    <Menu>
      <MenuItem onClick={() => {
        const textareaRef = this.textareaRef
        const selectionStart = textareaRef.selectionStart
        const selectionEnd = textareaRef.selectionEnd
        const selectedText = textareaRef.value.substring(selectionStart, selectionEnd)
        copyTextToClipBoard(selectedText || textareaRef.value.toString())
      }} text={i18next.t('Copy')} labelElement={
        <span className={hotKeyClass}>{`${ctrlOrCmd} + c`}</span>} />
      <MenuItem onClick={async () => {
        const clipText = await pasteTextFromClipBoard(this.textareaRef)
        this.onPaste(null, clipText)
      }} text={i18next.t('Paste')} labelElement={
        <span className={hotKeyClass}>{`${ctrlOrCmd} + v`}</span>} />
      <React.Fragment>{this.insertKeys.map((key) => (<MenuItem {...key.returnPropObjForMenuItem()} />))}</React.Fragment>
      <MenuDivider />
      <MenuItem text={i18next.t('Control')}>{[].concat(
        this.props.commonKeys.slice(0, 2).map((key) => (<MenuItem {...key.returnPropObjForMenuItem()} />
        )),
        <MenuDivider key={'d0'} />,
        this.props.commonKeys.slice(2, 3).map((key) => (<MenuItem {...key.returnPropObjForMenuItem()} />
        )),
        // <MenuDivider key={'d1'} />,
        <MenuItem key='Add node' text={i18next.t('Add Node')} icon={'add-to-artifact'}>{
          this.props.commonKeys.slice(3, 5).map((key) => (<MenuItem {...key.returnPropObjForMenuItem()} />
          ))
        }</MenuItem>,
        // <MenuDivider key={'d2'} />,
        <MenuItem key='transfer' text={i18next.t('Transfer')} icon={'exchange'}>
          {this.props.commonKeys.slice(5, 10).map((key, index) => (key === 'divider' ? <MenuDivider key={index} />
            : <MenuItem {...key.returnPropObjForMenuItem()} />
          ))}
        </MenuItem>,
        // <MenuDivider key={'d3'} />,
        <MenuItem key={'move'} text={i18next.t('Copy')} icon={'trending-up'}>{
          this.props.commonKeys.slice(10, 14).map((key, index) => (key === 'divider' ? <MenuDivider key={index} />
            : <MenuItem {...key.returnPropObjForMenuItem()} />
          ))
        }</MenuItem>,
        <MenuDivider key={'d4'} />,
        (this.props.commonKeys.slice(14).map((key) => (key.isForMenu ? <MenuItem {...key.returnPropObjForMenuItem()} /> : null
        )))
      )}
      </MenuItem>
    </Menu>
  )

  _onContextMenu = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('TextAreaMode onContextMenu')
    }
    ContextMenu.show(this._menu, { left: e.clientX, top: e.clientY })
  }
  _onBlur = (e) => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('TextAreaMode onBlur')
    }

    if (this.state.popoverOpen && !globalOnDemandVars.preventFocusSteal()) {
      this.setState({
        popoverOpen: false,
        onPaste: false
        // mediaUploadBoolean: false,
        // mediaUploadType: null
      })
      globalOnDemandVars.set_openNodePopover(false)
    }

    if (ContextMenu.isOpen()) {
      this.textareaRef.focus()
      e.preventDefault()
      e.stopPropagation()
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log('TextAreaMode preventDefault')
      }
      return false
    } else {
      this.props.toggleEditing()
    }
  }

  _onFocus = (e) => {
    const openNodePopover = globalOnDemandVars.openNodePopover()
    if (openNodePopover) {
      this.setState({
        popoverOpen: true
        // mediaUploadBoolean: true,
        // mediaUploadType: openNodePopover
      })
    }
    // else if (this.state.mediaUploadBoolean) {
    //   this.setState({
    //     popoverOpen: false,
    //     mediaUploadBoolean: false,
    //     mediaUploadType: null
    //   })
    // }
  }

  pasted = false

  onChange = (e) => {
    const originalString = e.target.value
    const parsedString = parseLogicSymbols(originalString)

    if (originalString !== parsedString) {
      const ref = this.textareaRef
      const difference = originalString.length - parsedString.length
      const caretPosition = ref.selectionStart
      const newCaretPosition = caretPosition - difference
      this.props.onChange({ target: { value: parsedString } })
      defer(() => {
        if (this.props.value === parsedString) {
          ref.setSelectionRange(newCaretPosition, newCaretPosition)
        }
      })
    } else {
      this.props.onChange(e)
    }

    if (!this.pasted && this.state.onPaste) {
      this.setState({ onPaste: false })
    } else {
      this.pasted = false
    }
  }

  onPaste = (e, pastedText) => {
    if (!this.props.isQuestionPart) {
      return
    }

    const pastedValue = pastedText || e.clipboardData.getData('Text')
    const words = pastedValue.split(' ')
    if (words.length >= 2) {
      this.pasted = true
      this.setState({
        popoverOpen: true,
        onPaste: true,
        pastedWords: words
      })
    }
  }

  render () {
    const {
      refCalc,
      moveToUpperET, moveToLowerET,
      ...otherProps
    } = this.props

    let popoverContent = null
    if (this.state.popoverOpen) {
      if (this.state.onPaste) {
        popoverContent = <PasteComp pastedWords={this.state.pastedWords} setState={(newValue) => { this.setState({ pastedWords: newValue }) }} onChange={this.nodeTextOnChange} value={this.props.value} />
      } else {
        popoverContent = <PreviewComp value={this.props.value} />
      }
    }

    return (
      <div>
        <Popover isOpen={this.state.popoverOpen} minimal
          position={'bottom-left'} targetClassName={classname`width: 100%;`}
          {...OverlayProps}
          content={popoverContent}>
          <textarea {...otherProps} ref={this.refF}
            onChange={this.onChange}
            onPaste={this.onPaste}
            onContextMenu={this._onContextMenu}
            onFocus={this._onFocus} onBlur={this._onBlur} onKeyDown={onKeyDown}
          />
        </Popover>
      </div>
    )
  }

  renderHotkeys () {
    return (<Hotkeys>{
      this.keys.concat(this.props.commonKeys, this.insertKeys).map((key, index) => (key === 'divider' ? null
        : (key.isForHotKey ? <Hotkey allowInInput preventDefault={
          !key.config.notPreventDefault && (index > 2 && !(key.text.startsWith('autoComplete') || key.text.startsWith('skip')))
        }
            {...key.returnPropObjForHotKey()} /> : null
        )))
    }</Hotkeys>)
  }
}
//
// const hotkeysTarget2 = (target) => {
//   return HotkeysTarget(target)
// }
//
// const blankF = (target) => {
//   return target
// }
// const hotkeysTarget3 = throttle(HotkeysTarget)
// //
// // // const TextAreaMode2 = hotkeysTarget2(TextAreaMode)
// //
// const TextAreaMode3 = hotkeysTarget3(TextAreaMode)
// // class TextAreaMode3 extends Component {
// //   render () {
// //     return (
// //       <TextAreaMode2 {...this.props} />
// //     )
// //   }
// // }
export default TextAreaMode
